import React, { FC, useState } from 'react';

import { Button } from '@mui/material';
import { translate } from '@utils/locale';
import PairPanelCard from '@components/pair-panel-card/PairPanelCard';

import { RoundDetailsCardProps } from './types';
import { StageValues } from '../../constants';
import InvestorsTable from '../../containers/InvestorsTable';

const RoundDetailsCard: FC<RoundDetailsCardProps> = ({
  data,
  companyStage,
  roundName,
  roundId,
  hasPortfolioUpdate,
  disableEdit = false
}) => {
  const [showInvestors, setShowInvestors] = useState(false);

  const onClickShowInvestors = () => {
    setShowInvestors(true);
  };

  const renderHeader = () => {
    return (
      <div className="flex items-center mb-[10px]">
        <span className="mr-[6px] text-xl font-semibold">{roundName}</span>
        <div className="mr-[6px] w-1 h-1 bg-grey rounded-[100%]" />
        <span className="text-base font-normal text-grey">
          {StageValues[companyStage as keyof typeof StageValues]}
        </span>
        {hasPortfolioUpdate && (
          <div
            className="py-[3px] px-[10px] ml-[15px] text-xs font-normal tracking-[0.16px] rounded-full"
            style={{ backgroundColor: '#CD7EFF' }}>
            {translate('company.addRound.portfolioChipLabel')}
          </div>
        )}
      </div>
    );
  };
  return (
    <div>
      <PairPanelCard
        header={renderHeader()}
        panelData={data}
        customStyle="!w-full !max-w-[80%]"
        childrenStyles="!w-[25%]"
      />
      <div className="flex justify-center py-5 !max-w-[80%]">
        {!showInvestors ? (
          <Button variant="text" onClick={onClickShowInvestors}>
            {translate('company.valuationTimeline.showInvestors')}
          </Button>
        ) : (
          <div className="w-full min-h-[300px]">
            <InvestorsTable
              showVisibleDealColumn={true}
              showEmptyState={true}
              roundId={roundId}
              disableEdit={disableEdit}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default RoundDetailsCard;
